import { IOverridingChart } from './overriding-chart.interface';
export interface IOverridingDistribution {
  id:number;
  overridingCharts:IOverridingChart[];
  code:string;
  name:string;
  isActive:boolean;
  status:string;
}
